import React, { useEffect } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import RoutesConfig from "./config/routes";
import { Toaster } from "react-hot-toast";
import useInactivityLogout from "./hooks/useInactivityLogout";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { requestNotificationPermission, setupNotificationListeners } from "./services/notification";

const AppWrapper = () => {
  const routes = useRoutes(RoutesConfig());
  useInactivityLogout();
  return routes;
};

function App() {
  useEffect(() => {
    // Request permission on load if already logged in
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      requestNotificationPermission();
    }
  }, []);

  useEffect(() => {
    // Setup foreground & background notification and audio listeners
    const cleanup = setupNotificationListeners();
    return () => {
      if (typeof cleanup === "function") {
        cleanup();
      }
    };
  }, []);

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Router>
          <AppWrapper />
        </Router>
      </LocalizationProvider>

      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
}

export default App;
